module.exports = __webpack_public_path__ + "media/invoice/invoice_requested-ba4044b9.svg";